import { columns } from './columns';
import React from 'react';
import { useSelector } from 'react-redux';
import VisitorTypePageLayout from './Layouts/visitorTypes';
import { filters } from './filters';
import visitorTypeDetails from './visitorTypeDetails';
import form from '../Visitors/Layouts/form';

const VisitorTypes = () => {
  const loading = useSelector(state => state.ui.loading);
  return (
    <VisitorTypePageLayout
      columns={columns}
      filtersRequired={true}
      filters={filters}
      editable={true}
      loading={loading}
      details={visitorTypeDetails}
      FormComponent={form}
    />
  );
};
export default VisitorTypes;
